<template>
  <ValidationObserver slim>
    <b-tr>
      <b-td :stacked-heading="$gettext('Room')" v-translate>Room {{ room }}</b-td>
      <b-td :stacked-heading="$gettext('Title')">
        <ValidationProvider
            :name="$gettext('Title')"
            :rules="{ required: true }"
            :vid="id + 'title'"
            v-slot="vContext"
          >
          <b-form-group>
            <b-form-select
              size="sm"
              v-model="pax.title"
              :options="titles"
              :state="getValidationState(vContext)"
              aria-describedby="title-live-feedback"
            >
            </b-form-select>
            <b-form-invalid-feedback id="title-live-feedback">{{ vContext.errors[0] }}</b-form-invalid-feedback>
          </b-form-group>
        </ValidationProvider>
      </b-td>
      <b-td :stacked-heading="$gettext('Last name')">
        <ValidationProvider
            :name="$gettext('Last name')"
            :rules="{ required: true, latin_only: true}"
            :vid="id + 'lname'"
            v-slot="vContext"
          >
          <b-form-group>
            <b-form-input
              type="text"
              :name="'nume'"
              :placeholder="$gettext('Last name*')"
              class="form-control form-control-sm"
              v-model="pax.lname"
              size="sm"
              :state="getValidationState(vContext)"
              aria-describedby="lname-live-feedback"
            ></b-form-input>
            <b-form-invalid-feedback id="lname-live-feedback">{{ vContext.errors[0] }}</b-form-invalid-feedback>
          </b-form-group>
        </ValidationProvider>
      </b-td>
      <b-td stacked-heading="Prenume">
        <ValidationProvider
            :name="$gettext('First name')"
            :rules="{ required: true, latin_only: true}"
            :vid="id + 'fname'"
            v-slot="vContext"
          >
          <b-form-group>
            <b-form-input
              type="text"
              :name="'prenume'"
              :placeholder="$gettext('First name*')"
              class="form-control form-control-sm"
              v-model="pax.fname"
              size="sm"
              :state="getValidationState(vContext)"
              aria-describedby="fname-live-feedback"
            ></b-form-input>
            <b-form-invalid-feedback id="fname-live-feedback">{{ vContext.errors[0] }}</b-form-invalid-feedback>
          </b-form-group>
        </ValidationProvider>
      </b-td>
      <b-td :stacked-heading="$gettext('Age')" v-translate>{{ pax.age }}</b-td>
      <b-td :stacked-heading="$gettext('Birthday')">
        <ValidationProvider
            :name="$gettext('Birthday')"
            :rules="{ required: true, validDate: { min: from, max: to } }"
            :vid="id + 'dob'"
            v-slot="vContext"
          >
          <b-form-group>
            <DatePicker
              v-model="dob"
              :state="getValidationState(vContext)"
              :defaultValue="defaultDate"
              :notBefore="from"
              :notAfter="to"
              size="sm"
              lang="en"
              :today-label="$gettext('today')"
              :selected-date-label="$gettext('selected date')"
              placeholder="dd/mm/yyyy"
              aria-describedby="dob-live-feedback"
            ></DatePicker>
            <b-form-invalid-feedback id="dob-live-feedback">{{ vContext.errors[0] }}</b-form-invalid-feedback>
          </b-form-group>
        </ValidationProvider>
      </b-td>
    </b-tr>
  </ValidationObserver>
</template>
<style scoped>
  fieldset {
    margin-bottom: 0px!important;
  }
</style>

<script>
import moment from 'moment'
import DatePicker from 'b2b-common/components/datepicker'
import { titles } from '@/shared/utils'
import validation from 'b2b-common/mixins/validation'
import { extend } from 'vee-validate'

extend('latin_only', {
  validate: (value) => /^[a-zA-Z\s]+$/.test(value),
  message: 'The {_field_} must only contain letters from the Latin alphabet.'
})

export default {
  name: 'PaxForm',
  mixins: [validation],
  props: {
    value: Object,
    room: Number,
    travelDate: Object,
    id: [String, Number],
    maxChildAge: {
      type: Number,
      default: 18
    }
  },
  components: { DatePicker },
  data () {
    return {
      pax: this.value,
      titles: titles.map(el => ({ value: el, text: el }))
    }
  },
  computed: {
    dob: {
      get () {
        if (!this.pax.bdate) return null
        return moment(this.pax.bdate, 'DD-MM-YYYY').toDate()
      },
      set (val) {
        if (val) this.pax.bdate = moment(val).format('DD-MM-YYYY')
        else this.pax.bdate = null
      }
    },
    defaultDate () {
      if (this.pax.age === 'adult') return moment(this.travelDate).subtract(30, 'years').toDate()
      if (this.pax.age === 'child') return moment(this.travelDate).subtract((this.maxChildAge - 1), 'years').add(1, 'days').toDate()
      if (this.pax.age === 'infant') return moment(this.travelDate).subtract(1, 'years').toDate()
      return moment(this.travelDate).subtract(this.pax.age, 'years').subtract(6, 'months').toDate()
    },
    from () {
      if (this.pax.age === 'adult') return null
      if (this.pax.age === 'child') return moment(this.travelDate).subtract(this.maxChildAge, 'years').add(1, 'days').toDate()
      if (this.pax.age === 'infant') return moment(this.travelDate).subtract(2, 'years').add(1, 'days').toDate()
      return moment(this.travelDate).subtract(this.pax.age + 1, 'years').add(1, 'days').toDate()
    },
    to () {
      if (this.pax.age === 'adult') return moment(this.travelDate).subtract(this.maxChildAge, 'years').toDate()
      if (this.pax.age === 'child') return moment(this.travelDate).subtract(2, 'years').toDate()
      if (this.pax.age === 'infant') return moment(this.travelDate).toDate()
      return moment(this.travelDate).subtract(this.pax.age, 'years').toDate()
    }
  }
}
</script>
